module.exports = __webpack_public_path__ + "static/tools-8c988debeb001d6eab4c67866cdb7894.svg";